<template>
  <aside class="pc-sidebar">
    <div class="sidebar-header">
      <div class="logo">
        <span class="logo-badge">微</span>
        <span class="logo-text">我的控制台</span>
      </div>
    </div>
    
    <nav class="pc-nav">
      <a 
        v-for="item in navItems" 
        :key="item.name"
        :href="item.link || 'javascript:void(0)'"
        class="pc-nav-item"
        :class="{ active: modelValue === item.name }"
        @click="handleClick($event, item)"
      >
        <span class="nav-icon">{{ item.icon }}</span>
        <span class="nav-label">{{ item.name }}</span>
      </a>
    </nav>

    <div class="sidebar-footer">
      <UserInfo :user-name="userName" avatar-text="A" />
    </div>
  </aside>
</template>

<script setup>
import { useRouter } from 'vue-router'
import UserInfo from '@/components/comm/UserInfo.vue'
import { ref } from 'vue'

const props = defineProps({
   
  modelValue: {
    type: String,
    default: '首页'
  },
  userName: {
    type: String,
    default: 'admin'
  }
})
const navItems = ref([
  { 
    name: '首页', 
    icon: '🏠', 
    link: '/',
    route: { name: 'Home' },
    target: '_self'
  },
  { 
    name: '商品管理', 
    icon: '📦', 
    link: '/Console',
    route: { name: 'Console' },
    target: '_self'
  } ,
  { 
    name: '订单管理', 
    icon: '🛒', 
    link: '/OrderList',
    route: { name: 'OrderList' },
    target: '_self'
  }, 
  { 
    name: '个人中心', 
    icon: '👤', 
     link: '/Account',
    route: { name: 'Account' },
    target: '_self'
  }, 
  { 
    name: '官网首页', 
    icon: '🌐', 
       link: '/',
    route: { name: 'NewsHome' },
  }  
])


const emit = defineEmits(['update:modelValue', 'navigate'])
const router = useRouter()

const handleClick = (event, item) => {
  // 阻止默认跳转，使用路由跳转
  event.preventDefault()
  
  // 更新当前选中状态
  emit('update:modelValue', item.name)
  emit('navigate', item)
  
  // 使用 Vue Router 进行跳转
  if (item.route) {
    router.push(item.route)
  } else if (item.link) {
    // 外部链接或普通链接
    if (item.link.startsWith('http')) {
      window.open(item.link, item.target || '_self')
    } else {
      router.push(item.link)
    }
  }
}
</script>

<style scoped>
.pc-sidebar {
  width: 260px;
  background: white;
  border-right: 1px solid #e0ecff;
  display: flex;
  flex-direction: column;
  height: 100vh;
  position: sticky;
  top: 0;
  flex-shrink: 0;
}

.sidebar-header {
  padding: 24px 20px;
  border-bottom: 1px solid #e0ecff;
}

.logo {
  display: flex;
  align-items: center;
  gap: 10px;
}

.logo-badge {
  background: #0066cc;
  color: white;
  width: 36px;
  height: 36px;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 700;
  font-size: 1.2rem;
}

.logo-text {
  font-weight: 600;
  color: #00377a;
  font-size: 1rem;
}

.pc-nav {
  flex: 1;
  padding: 20px 12px;
}

.pc-nav-item {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 16px;
  border-radius: 12px;
  color: #1e4870;
  cursor: pointer;
  margin-bottom: 4px;
  transition: all 0.2s;
  text-decoration: none;
}

.pc-nav-item:hover {
  background: #eef5ff;
  text-decoration: none;
  color: #1e4870;
}

.pc-nav-item.active {
  background: #e2f0ff;
  color: #0066cc;
  font-weight: 500;
}

.nav-icon {
  font-size: 1.3rem;
  width: 24px;
  text-align: center;
}

.sidebar-footer {
  padding: 20px;
  border-top: 1px solid #e0ecff;
}
</style>